import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import 'core-js/modules/es6.array.map.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es7.array.includes.js';
import 'core-js/modules/es6.string.includes.js';
import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var nonSearchableItemTypes = ["divider", "heading", "custom"];
var searchDropdownMenuItems = function searchDropdownMenuItems(items, search) {
  if (!search) return items;
  return items.filter(function (item) {
    if (nonSearchableItemTypes.includes(item.type)) return false;

    if (item.type === "radio") {
      return item.items.some(function (radioItem) {
        return radioItem.text.toLowerCase().includes(search);
      });
    }

    if (item.type === "submenu") {
      return searchDropdownMenuItems(item.items, search).length > 0;
    }

    if (item.type === "checkbox" || item.type === "default") {
      return item.text.toLowerCase().includes(search);
    }

    return true;
  }).map(function (item) {
    if (item.type === "radio") {
      return _objectSpread(_objectSpread({}, item), {}, {
        items: item.items.filter(function (radioItem) {
          return radioItem.text.toLowerCase().includes(search);
        })
      });
    }

    if (item.type === "submenu") {
      return _objectSpread(_objectSpread({}, item), {}, {
        items: searchDropdownMenuItems(item.items, search)
      });
    }

    return item;
  });
};

export { searchDropdownMenuItems };
//# sourceMappingURL=dropdown-menu-search-items.js.map
